module.exports = __webpack_public_path__ + "static/img/6.c2de0a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/6.png
// module id = bFru
// module chunks = 0